var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRotateClockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.48 14.465a6.271 6.271 0 01-4.465 1.846 6.273 6.273 0 01-4.466-1.846 6.321 6.321 0 010-8.931 6.273 6.273 0 014.466-1.847c1.596 0 3.1.586 4.264 1.656l-2.011 2.013 7.716 1.147L18.837.787 16.89 2.733A9.934 9.934 0 0010.015 0 9.938 9.938 0 002.94 2.926c-3.9 3.9-3.9 10.247 0 14.149A9.943 9.943 0 0010.015 20a9.94 9.94 0 007.074-2.926l.195-.196-2.61-2.61-.194.197z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.914 12.263a2.165 2.165 0 100-4.331 2.165 2.165 0 000 4.33z"
  })));
}

export default SvgRotateClockwise;